import React from 'react';
import StoriesListPage from './list';

const SharedWithMePage = () => <StoriesListPage notMine title="Shared With Me" />;

export default SharedWithMePage;
